/* us-banners.js - controller for sections/us-banners.liquid.
   APG carousel: real buttons, inert hidden slides, aria-live polite once
   autoplay stops, pause on hover / focus / hidden tab, swipe on touch, no
   autoplay under prefers-reduced-motion. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Banners(root) {
    var slides = root.querySelectorAll('[data-usb-slide]');
    var dots = root.querySelectorAll('[data-usb-dot]');
    var live = root.querySelector('[data-usb-live]');
    var count = slides.length;
    if (!count) return;
    var index = 0, timer = null, playing = false;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var auto = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reduced;
    root.style.setProperty('--usb-interval', interval + 'ms');

    function show(next) {
      index = (next + count) % count;
      for (var i = 0; i < count; i++) {
        var on = i === index;
        slides[i].classList.toggle('is-current', on);
        if (on) slides[i].removeAttribute('inert'); else slides[i].setAttribute('inert', '');
        if (dots[i]) {
          dots[i].setAttribute('aria-current', on ? 'true' : 'false');
          var bar = dots[i].querySelector('span');
          if (on && bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        }
      }
      /* Lazy plates and cut-outs of the next slide start loading early. */
      var ahead = slides[(index + 1) % count];
      if (ahead) ahead.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    function tick() { show(index + 1); }
    function start() {
      if (!auto || playing) return;
      playing = true;
      root.setAttribute('data-paused', 'false');
      if (live) live.setAttribute('aria-live', 'off');
      timer = window.setInterval(tick, interval);
    }
    function stop() {
      playing = false;
      root.setAttribute('data-paused', 'true');
      if (live) live.setAttribute('aria-live', 'polite');
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function goTo(n) { stop(); show(n); }

    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-usb-prev], [data-usb-next], [data-usb-dot]');
      if (!el) return;
      if (el.hasAttribute('data-usb-prev')) goTo(index - 1);
      else if (el.hasAttribute('data-usb-next')) goTo(index + 1);
      else goTo(parseInt(el.getAttribute('data-index'), 10) || 0);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    if (auto) {
      root.addEventListener('mouseenter', function () { if (timer) { window.clearInterval(timer); timer = null; } root.setAttribute('data-paused', 'true'); });
      root.addEventListener('mouseleave', function () { if (playing && !timer) { root.setAttribute('data-paused', 'false'); show(index); timer = window.setInterval(tick, interval); } });
      root.addEventListener('focusin', function (e) { if (e.target.closest('.usb__controls, .usb__cta, .usb__tag')) stop(); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { if (timer) { window.clearInterval(timer); timer = null; } }
        else if (playing && !timer) timer = window.setInterval(tick, interval);
      });
    }
    show(0);
    root.setAttribute('data-ready', 'true');
    if (auto) start(); else stop();
  }

  function init(scope) { (scope || document).querySelectorAll('[data-usb]:not([data-ready])').forEach(Banners); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
